import { Validator } from 'fluentvalidation-ts';
import { beAnInteger, bePositiveNumber } from '../../../../validators/stringValidators';

export type UnitExtraPartFormModel = {
  partId: number;
  quantity: string;
};

export const getInitialUnitExtraPartFormModel = (partId: number): UnitExtraPartFormModel => ({
  partId,
  quantity: '1',
});

export class UnitExtraPartFormModelValidator extends Validator<UnitExtraPartFormModel> {
  constructor() {
    super();

    this.ruleFor('quantity')
      .notEmpty()
      .must(beAnInteger)
      .must(bePositiveNumber);
  }
}
